export default __webpack_public_path__ + "static/media/03en.1fd69a58.mp3";